/**
 * Cart Address Sync
 * Handles prefilling, saving, and syncing address to cart attributes
 */

(function() {
  'use strict';

  window.CartAddressSync = {
    saveTimeout: null,
    isPrefilling: false,

    /**
     * Prefill form from cart
     */
    prefill(container) {
      this.isPrefilling = true;
      
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const props = cart.attributes || {};

          // Prefill fields
          container.querySelectorAll('[data-prop]').forEach(input => {
            const key = input.dataset.prop;
            if (input.type === 'radio') {
              input.checked = props[key] === input.value;
            } else if (props[key]) {
              input.value = props[key];
            }
          });
          
          this.isPrefilling = false;
        })
        .catch(err => {
          console.error('Error prefilling cart address:', err);
          this.isPrefilling = false;
        });
    },

    /**
     * Save address to cart (debounced)
     */
    save(container, validation) {
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(() => {
        // Validate before saving (don't show errors)
        if (!validation.validateAll(container, false)) {
          return;
        }

        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const merged = { ...(cart.attributes || {}) };

            container.querySelectorAll('[data-prop]').forEach(input => {
              const key = input.dataset.prop;

              if (input.type === 'radio') {
                if (input.checked) merged[key] = input.value;
              } else {
                merged[key] = input.value;
              }
            });

            // Update cart attributes
            const updateUrl = (typeof routes !== 'undefined' && routes.cart_update_url) || '/cart/update.js';
            const body = JSON.stringify({
              attributes: merged
            });
            fetch(updateUrl, {
              ...(typeof fetchConfig !== 'undefined' ? fetchConfig() : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
              }),
              body
            });
          })
          .catch(err => {
            console.error('Error saving cart address:', err);
          });
      }, 400);
    },

    /**
     * Sync address to new cart items
     * Note: Since addresses are now stored as cart attributes (cart-level),
     * this function is no longer needed but kept for backward compatibility
     */
    syncToNewItems() {
      // Cart attributes are already cart-level, so no syncing needed
      // This function is kept for backward compatibility but does nothing
      return;
    }
  };
})();

